import angular from 'angular';
import 'ng-file-upload';

const competitionsServices = angular.module('applicationModule.competitionsServices', []);

competitionsServices.factory('Competition', ['CompetitionAPI', 'AppsoupAPI', 'Upload', function (CompetitionAPI, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/competitions/';

    const checkFiles = function (file) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }

        return {files: files, names: names};
    };

    return {
        getList: function (appId, params) {
            return CompetitionAPI.getAllCompetitions(appId, params)
                .then(function (response) {
                    return response.data.competitions;
                });
        },
        get: function (competitionId, appId) {
            return CompetitionAPI.getCompetitions(competitionId, appId);
        },
        save: function (competition, file, editMode) {
            const files = checkFiles(file);
            if (editMode) {
                if (angular.isDefined(file)) {
                    const newfields = angular.extend(competition, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + 'update/' + competition.id,
                        sendObjectsAsJsonBlob: false,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return CompetitionAPI.storeCompetition(competition, editMode);
                }
            } else {
                if (angular.isDefined(file)) {
                    return Upload.upload({
                        url: API_URL + 'create',
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: competition,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return CompetitionAPI.storeCompetition(competition);
                }
            }
        },
        remove: function (competitionId, appId) {
            return CompetitionAPI.removeCompetition(competitionId, appId);
        },
        copy: function (competitionId) {
            return CompetitionAPI.copy(competitionId);
        }
    };
}]);

competitionsServices.service('CompetitionAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/competitions/';

    this.getAllCompetitions = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getCompetitions = function (competitionId, appId) {
        return $http.get(API_URL + competitionId, {params: {application_id: appId}});
    };

    this.storeCompetition = function (competition, editMode) {
        if (editMode) {
            return $http.put(API_URL + 'update/' + competition.id, competition);
        } else {
            return $http.post(API_URL + 'create', competition);
        }
    };

    this.removeCompetition = function (competitionId) {
        return $http.delete(API_URL + 'delete/' + competitionId);
    };

    this.copy = function (competitionId) {
        return $http.get(API_URL + 'copy/' + competitionId);
    };
}]);

export default competitionsServices;
